import * as XLSX from "xlsx";

// Excel stores a zero-padded code as a NUMBER wearing a display mask: 001128 is the
// integer 1128 formatted "000000". SheetJS keeps both — the raw value (1128, zeros
// gone) and the painted text (cell.w, "001128"). Reading raw loses every leading zero
// in a barcode or account-code column.
//
// Reading everything as text is NOT the answer: cell.w also turns a General-formatted
// 13-digit EAN into "6.29104E+12" and a #,##0 quantity into "1,234,567", which
// parseFloat then reads as 1. So the painted text is trusted only when it is the raw
// number with zeros in front of it, and never otherwise.
const ZERO_PADDED = /^0\d+$/;

const pickCell = (value, text) => {
  const painted = text !== undefined && text !== null ? String(text).trim() : "";
  if (ZERO_PADDED.test(painted) && Number(painted) === value) return painted;

  const str = value !== undefined && value !== null ? String(value).trim() : "";
  const lower = str.toLowerCase();
  return lower === "null" || lower === "undefined" ? "" : str;
};

// Reads a worksheet into a plain string matrix, preserving leading zeros.
// Row 0 is the header row, exactly as sheet_to_json({ header: 1 }) returned it.
export const readSheetCells = (sheet) => {
  const values = XLSX.utils.sheet_to_json(sheet, { header: 1 });
  // Same shape, same column positions — only the cell projection differs, so the two
  // matrices line up index for index.
  const texts = XLSX.utils.sheet_to_json(sheet, {
    header: 1,
    raw: false,
    defval: "",
  });

  return values.map((row, r) =>
    (row || []).map((value, c) => pickCell(value, texts[r] && texts[r][c])),
  );
};
